import React__default from 'react';
import cn from 'classnames';
import styles from 'ui-components/Toggle.scss';

var Toggle = function Toggle(_ref) {
  var _ref2;
  var className = _ref.className,
    variant = _ref.variant,
    name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange;
  var id = "toggle_" + name;
  var variants = typeof variant === "string" ? variant.split(" ").map(function (x) {
    return styles[x];
  }) : [];
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn.apply(void 0, [className, (_ref2 = {}, _ref2[styles.active] = value, _ref2)].concat(variants))
  }, /*#__PURE__*/React__default.createElement("input", {
    className: styles.input,
    id: id,
    type: "checkbox",
    name: name,
    value: value,
    onChange: onChange
  }), /*#__PURE__*/React__default.createElement("label", {
    className: styles.label,
    htmlFor: id,
    role: "checkbox",
    "aria-checked": value,
    "aria-labelledby": id
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.railWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.rail
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.handle
  })))));
};

export { Toggle };
//# sourceMappingURL=index.js.map
